import { css, unsafeCSS } from 'lit';
import { sbkCoreBreakpointMd } from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const facet3 = css`
  :host {
  }
    
  .image__facet-3 {
      ::slotted(img), ::slotted(picture) {
          object-fit: cover;
          clip-path: polygon( 50.025% 1.4%,4.925% 27.425%,4.9% 79.5%,27.45% 92.525%,27.45% 92.525%,31.726% 94.699%,36.158% 96.392%,40.707% 97.602%,45.334% 98.33%,50% 98.575%,54.666% 98.337%,59.293% 97.616%,63.842% 96.411%,68.274% 94.723%,72.55% 92.55%,72.55% 92.55%,72.55% 92.55%,76.571% 89.936%,80.252% 86.946%,83.573% 83.613%,86.514% 79.971%,89.056% 76.053%,91.18% 71.893%,92.866% 67.524%,94.094% 62.98%,94.845% 58.294%,95.1% 53.5%,95.1% 53.5%,95.1% 53.5%,94.846% 48.712%,94.097% 44.029%,92.871% 39.486%,91.189% 35.116%,89.069% 30.953%,86.53% 27.031%,83.592% 23.383%,80.274% 20.044%,76.596% 17.047%,72.575% 14.425%,50.025% 1.4% );
          aspect-ratio: 1;
          height: auto;
          width: 100%;
          z-index: 2;
      }
  }

  .image-facet-3-md {
    display: none;
  }
  .image-facet-3-lg {
    display: block;
      position: absolute;
      top: -0.6%;
      left: -8.8%;
      width: 140%;
      height: auto;
      z-index: 1;
  }

    .image__facet-3--crop-mobile {
        ::slotted(img), ::slotted(picture) {
            clip-path: polygon( 0% 0%,0.028% 71.815%,25.028% 91.074%,25.028% 91.074%,29.777% 94.283%,34.694% 96.777%,39.738% 98.556%,44.866% 99.621%,50.035% 99.972%,55.202% 99.61%,60.325% 98.535%,65.36% 96.748%,70.266% 94.248%,75% 91.037%,75% 91.037%,79.458% 87.155%,83.536% 82.72%,87.213% 77.781%,90.468% 72.388%,93.281% 66.588%,95.632% 60.432%,97.5% 53.968%,98.864% 47.246%,99.704% 40.314%,100% 33.222%,100% 33.222%,99.93% 29.68%,99.72% 26.169%,99.375% 22.696%,98.895% 19.267%,98.285% 15.889%,97.546% 12.569%,96.682% 9.313%,95.694% 6.129%,94.587% 3.022%,93.361% 0%,0% 0% );
            aspect-ratio: 4 / 3;
            height: auto;
            width: inherit;
            margin: 0;
            z-index: 2;
        }
        .image-facet-3-md {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: auto;
            z-index: 1;
        }
        .image-facet-3-lg {
            display: none;
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                clip-path: polygon( 50.025% 1.4%,4.925% 27.425%,4.9% 79.5%,27.45% 92.525%,27.45% 92.525%,31.726% 94.699%,36.158% 96.392%,40.707% 97.602%,45.334% 98.33%,50% 98.575%,54.666% 98.337%,59.293% 97.616%,63.842% 96.411%,68.274% 94.723%,72.55% 92.55%,72.55% 92.55%,72.55% 92.55%,76.571% 89.936%,80.252% 86.946%,83.573% 83.613%,86.514% 79.971%,89.056% 76.053%,91.18% 71.893%,92.866% 67.524%,94.094% 62.98%,94.845% 58.294%,95.1% 53.5%,95.1% 53.5%,95.1% 53.5%,94.846% 48.712%,94.097% 44.029%,92.871% 39.486%,91.189% 35.116%,89.069% 30.953%,86.53% 27.031%,83.592% 23.383%,80.274% 20.044%,76.596% 17.047%,72.575% 14.425%,50.025% 1.4% );
                aspect-ratio: 1;
                height: auto;
                width: 100%;
            }
            .image-facet-3-md {
                display: none;
            }
            .image-facet-3-lg {
                display: block;
            }
        }
    }
`;